module.exports = __webpack_public_path__ + "img/syzn.7bdf7e03.png";